import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Digitalt';
    src: local('Digitalt'), url('/fonts/Digitalt/Digitalt.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Familjen-Grotesk';
    src: local('Familjen-Grotesk'), url('/fonts/Familjen-Grotesk/FamiljenGrotesk-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url('/fonts/Inter/Inter-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: bold;
    src: local('Inter'), url('/fonts/Inter/Inter-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Space-Grotesk';
    src: local('Space-Grotesk'), url('/fonts/SpaceGrotesk/SpaceGrotesk-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Bricolage-Grotesque';
    src:  
      url('/fonts/Bricolage_Grotesque/BricolageGrotesque-Regular.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-Bold.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-ExtraBold.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-ExtraLight.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-Light.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-Medium.ttf') format('truetype'),
      url('public/fonts/Bricolage_Grotesque/BricolageGrotesque-SemiBold.ttf') format('truetype');
  }


  body {
    font-family: 'Bricolage-Grotesque', sans-serif;
    color: #FAFFFF;

    img {
      height: auto;
    }

    top: 0 !important;
  }

  .container {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    max-width: 1300px;
    padding: 0 14px;
    margin: 0 auto;
  }

  .underline {
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    background: linear-gradient(99.46deg, #fa00ff -10.9%, #00e0ff 97.13%, #2ad4f9 97.14%);
    height: 2px;
    width: 100%;
  }

  .rotate {
    transform: rotate(180deg);
  }

  .error {
    font-size: 12px;
    color: #FF4842;
  }

  .ant-form-item-explain-error {
    color: #FF0F00
  }

  .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error {
    border-color: #FF0F00 !important;
  }

  // ant select dropdown
  .simple-select {
    .ant-form-item {
      margin: 0;
    }
    .ant-select-dropdown {
      padding: 0; 
      background: #161c1c; 
      border-radius: 4px; 
      overflow: hidden;
    }
    .ant-select-item {
      color: rgb(230 247 255); 
    }
    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      color: #00349D; 
      background: #161c1c; 
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      color: #00349D; 
      background: #161c1c; 
    }
    .ant-select-arrow {
      img {
        transform: rotate(180deg);
      }
    }
    .ant-select-open .ant-select-arrow {
      img {
        transform: rotate(0deg);
      }
    }
    
  }

  #google_translate_element, .skiptranslate iframe{
    display: none;
  }

  .ant-modal-title{
    color: #FDFFFA;
    font-size: 18px;
    line-height: 24px;
    font-style: normal;
    font-weight: 700;

    ${({ theme }) => theme.mediaQueries.lg} {
      font-size: 20px;
      line-height: 22px;
    }
  }

  .ant-pagination-item{
    &:hover {
      border-color: #00349D;
    
      a{
        color: #00349D;
      }
    }
  }

  .ant-pagination-item-active, .ant-pagination-prev:hover .ant-pagination-item-link, .ant-pagination-next:hover .ant-pagination-item-link{
    border-color: #00349D;
    color: #00349D;
    
    a{
      color: #00349D;
    }
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #00349D !important;
      border-color: #00349D;

      &::after {
        border: 3px solid #FFF;
        border-top: 0;
        border-left: 0;
      }
    }
  }

  .ant-checkbox-wrapper {
    &:hover {
      .ant-checkbox-inner {
        border-color: #00349D
      }
    }
  }

  .ant-checkbox-inner {
    width: 24px;
    height: 24px;

    &::after {
      width: 7px;
      height: 15px;
    }

    &:hover,
    &:focus {
      border-color: #00349D !important;
    }
  }

  .history-select-popup {
    min-width: 175px !important;

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: transparent;

      .ant-select-item-option-content {
        color: #00349D;
      }
    }
  }
  
`

export default GlobalStyle
